export const CONFIG = {
    script_key: '9f639544a4a13d7e0c12988cfd04c097',
    settings: {
        w: 16610,
        sid: 10859,
    },
};
